import declare from "dojo/_base/declare";
import ToolbarPluginButton from "csi/view/ToolbarPluginButton";

const RECIPE_DATA_SHEET = "RecipeDataSheet";
const FOOD_BOM = "FoodBOM";

const RecipeLabelItemToolbarPlugin = declare(ToolbarPluginButton, {

	/**
     * @override
     * Only show calculate actions on FoodLabelDataSheetRevision if it's owned by a RecipeDataSheet
     */
	validatePlugin(ctx) {
		try {
			const foodLabelParentNode = ctx.cache.getPathNode(ctx.getParent(), "Child:__Parent__/Child:__Parent__");
			return foodLabelParentNode && (foodLabelParentNode.$Type === RECIPE_DATA_SHEET || foodLabelParentNode.$Type === FOOD_BOM) ;
		} catch (e) {
			return false;
		}
	},
});

export = RecipeLabelItemToolbarPlugin;